import cssClasses from "./UnitDetailsModal.module.css";
import Close from "../../Components/Icons/Close";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";

function UnitDetailsModal({ data, open, closeHandler, alloted }) {
  const date = new Date(alloted);


const selectedData = data?.allotmentPaymentId?.unitId

  const options = {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  const filteredDate = date
    .toLocaleDateString("en-US", options)
    .replace(/,/g, "");
  const formattedDate = `${filteredDate},
    ${date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })}`;

  return (
    <>
      <Modal
        open={open}
        onClose={closeHandler}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={cssClasses.container}>
          <div className={cssClasses.header} style={{ marginBottom: "1rem" }}>
            <p className={cssClasses.heading}>Unit-Details - {data?.leadId?.personId?.name}</p>
            <Box
                    ml={"auto"}
                    mt={1}
                    onClick={closeHandler}
                    style={{ cursor: "pointer" }}
                  >
                    <Close width={"1.2rem"} height={"1.2rem"} />
                  </Box>
           
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {" "}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "85%",
                marginTop: "2rem",
                border: "0.1rem solid #707B9A",
                borderRadius: "0.7rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "1.3rem 1.5rem",
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "1rem",
                }}
              >
                <div className={cssClasses.subHeader}>
                  <p className={cssClasses.innerTextProject}>
                    {" "}
                    {`${selectedData?.wingId?.wingName}`}
                  </p>
                  <p style={{ opacity: "0.5" }}>
                    {" "}
                    {`${selectedData?.projectId?.projectName}`}
                  </p>
                </div>

                <div
                  style={{
                    fontSize: "1.1rem",
                    padding: "0 1.7rem",
                    display: "flex",
                    gap: "1rem",
                  }}
                >
                  <p> Lead Name : </p>
                  <p>{`${data?.leadId?.personId?.name}`}</p>
                </div>
                <div
                  style={{
                    fontSize: "1.1rem",
                    padding: "0 1.7rem",
                    display: "flex",
                    gap: "1rem",
                  }}
                >
                  <p>
                    {`${selectedData?.inventoryTypeId?.type}
                    (${selectedData?.displayUnitType}) |
                    ${data?.allotmentPaymentId?.paymentId === null ? "" : `${data?.allotmentPaymentId?.paymentId?.eventId?.title} |`}
                    ${selectedData?.floorNo} | Area
                    ${selectedData?.chargeableArea} sq.ft`}
                  </p>
                </div>
                <div
                  style={{
                    fontSize: "1.1rem",
                    padding: "0 1.7rem",
                    display: "flex",
                    gap: "1rem",
                  }}
                >
                  <p> Alloted On : </p>
                  <p>{`${formattedDate}`}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default UnitDetailsModal;
